export default __webpack_public_path__ + "static/media/peep-60.17ec64a0.svg";